import { createContext, useState, ReactNode } from "react";

interface ContextType {
    modelOpen: boolean;
    setModelOpen: (value: boolean) => void;
}

export const Contaxt = createContext<ContextType>({
    modelOpen: false,
    setModelOpen: () => {}
});

interface AppContextProps {
    children: ReactNode;
}

export function AppContext({children}: AppContextProps){
    const [modelOpen, setModelOpen] = useState(false);
    return(
        <Contaxt.Provider value={{modelOpen, setModelOpen}}>
            {children}
        </Contaxt.Provider>
    )
}